__turbopack_context__.v({
  "borderless": "VideoPlayer-module__Gdq1wG__borderless",
  "controlButtonElement": "VideoPlayer-module__Gdq1wG__controlButtonElement",
  "controlButtons": "VideoPlayer-module__Gdq1wG__controlButtons",
  "root": "VideoPlayer-module__Gdq1wG__root",
  "secondaryButtons": "VideoPlayer-module__Gdq1wG__secondaryButtons",
  "seekbar": "VideoPlayer-module__Gdq1wG__seekbar",
  "small-btn": "VideoPlayer-module__Gdq1wG__small-btn",
});
